import type { SiteContent } from '../content/types';
import { PageHero } from '../components/sections/page-hero';
import { ServicesGrid } from '../components/sections/services-grid';

interface ServicesPageProps {
  content: SiteContent;
}

export function ServicesPage({ content }: ServicesPageProps): JSX.Element {
  return (
    <>
      <PageHero title={content.servicesSection.headline} text={content.servicesSection.intro} />
      <ServicesGrid content={content} />
    </>
  );
}
